import styled from 'styled-components';

export const ContentSection = styled.div`
  width: 80%;
  margin: 0 auto;
  text-align: center;
`;

export const HereLink = styled.span`
  text-decoration: underline;
  cursor: pointer;
`;
